import {
  call, put, select, takeLatest, takeLeading,
} from 'redux-saga/effects';
import { apiCopyContact } from '../../copy-contacts/api/ContactCopyAPI';
import { apiGetContactDetail, apiEditContact } from '../../edit-contact/api/EditContactAPI';
import {
  postCopyContactSuccessActionCreator,
  postCopyContactFailureActionCreator,
  deleteContactFailureActionCreator,
  deleteContactSuccessActionCreator,
  getAllDataLocationsSuccessActionCreator,
  getAllDataLocationsFailureActionCreator,
  getAllImpcLocationsSuccessActionCreator,
  getAllImpcLocationsFailureActionCreator,
  addNewContactSuccessActionCreator,
  addNewContactFailureActionCreator,
  checkEmailAddressSuccessActionCreator,
  checkEmailAddressFailureActionCreator,
  getContactDetailsSuccessActionCreator,
  getContactDetailsFailureActionCreator,
  editContactSuccessActionCreator,
  editContactFailureActionCreator,
} from '../actions/ContactsActions';
import {
  COPY_CONTACTS_REQUEST,
  DELETE_CONTACT_REQUEST,
  GET_ALL_DATA_LOCATIONS_DEFAULT_REQUEST,
  GET_ALL_IMPC_LOCATIONS_DEFAULT_REQUEST,
  ADD_NEW_CONTACT_REQUEST,
  CHECK_EMAIL_ADDRESS_REQUEST,
  GET_CONTACT_DETAILS_REQUEST,
  EDIT_CONTACT_REQUEST,
} from '../actions/types/ContactsActionTypes';
import { showNotification } from '../../../../../common/notifications/redux/actions/NotificationActions';
import { formatMessage } from '../../../../../../locales/locales';
import { languageSelector } from '../../../../../common/redux/selectors/languageSelector';
import {
  apiDeleteContact,
  apiFetchCheckEmailAddressDefault,
  apiGetDataLocationListDefault,
} from '../../api/MrdContactsAPI';
import { apiFetchImpcsWithMrdsDefault } from '../../../../../common/impc/api/ImpcAPI';
import { apiAddNewContact } from '../../create/api/MrdContactsCreateAPI';

function* postCopyContactWorker(action) {
  const lang = yield select(languageSelector);
  try {
    const res = yield call(apiCopyContact, action.payload);
    yield put(postCopyContactSuccessActionCreator(res.data));
    yield put(showNotification({
      type: 'SUCCESS',
      message: formatMessage(lang, 'notification.contacts.copy.success'),
    }));
  } catch (error) {
    yield put(postCopyContactFailureActionCreator(error));
    yield put(showNotification({
      type: 'ERROR',
      message: error?.response?.data?.message || 'request failed',
    }));
  }
}

function* deleteContactWorker(action) {
  const lang = yield select(languageSelector);
  try {
    const res = yield call(apiDeleteContact, action.payload);
    yield put(deleteContactSuccessActionCreator(res.data));
    yield put(showNotification({
      type: 'SUCCESS',
      message: formatMessage(lang, 'notification.contacts.delete.success'),
    }));
  } catch (error) {
    yield put(deleteContactFailureActionCreator(error));
    yield put(showNotification({
      type: 'ERROR',
      message: error?.response?.data?.message || 'request failed',
    }));
  }
}

function* getAllDataLocationsWorker(action) {
  try {
    const res = yield call(apiGetDataLocationListDefault, action.payload);
    yield put(getAllDataLocationsSuccessActionCreator(res.data));
  } catch (error) {
    yield put(getAllDataLocationsFailureActionCreator(error));
  }
}

function* getAllImpcLocationsWorker(action) {
  try {
    const res = yield call(apiFetchImpcsWithMrdsDefault, action.payload);
    yield put(getAllImpcLocationsSuccessActionCreator(res.data));
  } catch (error) {
    yield put(getAllImpcLocationsFailureActionCreator(error));
  }
}

function* checkEmailAddressDefaultWorker(action) {
  try {
    const res = yield call(apiFetchCheckEmailAddressDefault, action.payload);
    yield put(checkEmailAddressSuccessActionCreator(res.data));
  } catch (error) {
    yield put(checkEmailAddressFailureActionCreator(error));
  }
}

function* postAddNewContactWorker(action) {
  const lang = yield select(languageSelector);
  try {
    const res = yield call(apiAddNewContact, action.payload);
    yield put(addNewContactSuccessActionCreator(res.data));
    yield put(showNotification({
      type: 'SUCCESS',
      message: formatMessage(lang, 'notification.contacts.add.success'),
    }));
  } catch (error) {
    yield put(addNewContactFailureActionCreator(error));
    yield put(showNotification({
      type: 'ERROR',
      message: error.response.data.message || formatMessage(lang, 'notification.contacts.add.failure'),
    }));
  }
}

function* getContactDetailsWorker(action) {
  try {
    const res = yield call(apiGetContactDetail, action.payload);
    yield put(getContactDetailsSuccessActionCreator(res.data));
  } catch (error) {
    yield put(getContactDetailsFailureActionCreator(error));
  }
}

function* editContactWorker(action) {
  const lang = yield select(languageSelector);
  try {
    const res = yield call(apiEditContact, action.payload);
    yield put(editContactSuccessActionCreator(res.data));
    yield put(showNotification({
      type: 'SUCCESS',
      message: formatMessage(lang, 'notification.contacts.edit.success'),
    }));
  } catch (error) {
    yield put(editContactFailureActionCreator(error));
    yield put(showNotification({
      type: 'ERROR',
      message: error.response.data.message || formatMessage(lang, 'notification.contacts.edit.failure'),
    }));
  }
}

function* contactWatcher() {
  yield takeLeading(COPY_CONTACTS_REQUEST, postCopyContactWorker);
  yield takeLatest(DELETE_CONTACT_REQUEST, deleteContactWorker);
  yield takeLatest(GET_ALL_DATA_LOCATIONS_DEFAULT_REQUEST, getAllDataLocationsWorker);
  yield takeLatest(GET_ALL_IMPC_LOCATIONS_DEFAULT_REQUEST, getAllImpcLocationsWorker);
  yield takeLatest(ADD_NEW_CONTACT_REQUEST, postAddNewContactWorker);
  yield takeLatest(CHECK_EMAIL_ADDRESS_REQUEST, checkEmailAddressDefaultWorker);
  yield takeLatest(GET_CONTACT_DETAILS_REQUEST, getContactDetailsWorker);
  yield takeLeading(EDIT_CONTACT_REQUEST, editContactWorker);
}
export default contactWatcher;
export {
  postCopyContactWorker,
  deleteContactWorker,
  getAllDataLocationsWorker,
  getAllImpcLocationsWorker,
  checkEmailAddressDefaultWorker,
  postAddNewContactWorker,
  getContactDetailsWorker,
  editContactWorker,
};
